import { useI18n } from '../i18n';
import styles from './HowItWorks.module.css';

export function HowItWorks() {
  const { t } = useI18n();

  return (
    <section className={styles.section} id="how">
      <h2 className={styles.heading}>{t.how.heading}</h2>

      <div className={styles.grid}>
        <div className={styles.column}>
          {t.how.steps.map((step) => (
            <div key={step.number} className={styles.card}>
              <div className={styles.number}>{step.number}</div>
              <h3 className={styles.cardTitle}>{step.title}</h3>
              <p className={styles.cardBody}>
                {step.body}
                {step.code ? (
                  <>
                    {' '}
                    <code className={styles.code}>{step.code}</code>.
                  </>
                ) : null}
              </p>
            </div>
          ))}
        </div>

        <div className={styles.feature}>
          <div className={styles.featureNumber}>{t.how.feature.number}</div>
          <h3 className={styles.featureTitle}>{t.how.feature.title}</h3>
          <p className={styles.featureBody}>{t.how.feature.body}</p>
        </div>
      </div>
    </section>
  );
}
